module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "label": "Small",
      "custom-class": "is-small"
    }
  }, [_c('b-input', {
    attrs: {
      "value": "Kevin Garvey",
      "size": "is-small"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Large",
      "custom-class": "is-large"
    }
  }, [_c('b-input', {
    attrs: {
      "value": "Kevin Garvey",
      "size": "is-large"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Danger",
      "custom-class": "has-text-danger",
      "type": "is-danger",
      "message": "This email is invalid"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "email",
      "value": "john@",
      "maxlength": "30"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Multiple (small and success)",
      "custom-class": "is-small has-text-success",
      "type": "is-success"
    }
  }, [_c('b-input', {
    attrs: {
      "value": "johnsilver",
      "maxlength": "30",
      "size": "is-small"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Computed (medium and primary)",
      "custom-class": _vm.classes,
      "type": "is-primary"
    }
  }, [_c('b-input', {
    attrs: {
      "value": "johnsilver",
      "maxlength": "30",
      "size": "is-medium"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b58be16"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/field/examples/ExCustomClass.vue
// module id = 1084
// module chunks = 5 131